var socialReviewsCarousel = {
  init: function() {
    $('.js-social-reviews-carousel').each(function (index, element) {
      var $carousel = $(element);
      var slideCount = $carousel.find('.gallery-cell').length;
      
      if (slideCount <= 1) {
        return;
      }

      var windowWidth = $(window).width();
      var isLargeScreen = windowWidth >= 1800;
      var isDesktop = windowWidth >= 1439 && windowWidth < 1800;
      var isTablet = windowWidth >= 768 && windowWidth < 1438;
      var isMobile = windowWidth < 768;
      
      if ($carousel.hasClass('flickity-enabled')) {
        $carousel.flickity('destroy');
      }

      $carousel.find('.gallery-cell').css('width', '');

      var flickityOptions = {
        cellAlign: 'left',
        draggable: true,
        freeScroll: false,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        contain: true,
        cellSelector: '.gallery-cell',
        groupCells: false,
        adaptiveHeight: false,
        setGallerySize: false
      };
      
      if (isLargeScreen) {
        flickityOptions.cellAlign = 'right';
        flickityOptions.contain = true;
      } else if (isDesktop) {
        flickityOptions.cellAlign = 'right';
        flickityOptions.contain = true;
      } else if (isTablet) {
        flickityOptions.cellAlign = 'right';
        flickityOptions.contain = true;
      } else {
        flickityOptions.cellAlign = 'left';
        flickityOptions.contain = true;
      }

      $carousel.flickity(flickityOptions);

      if (isLargeScreen) {
        $carousel.find('.gallery-cell').css('width', 'calc(29.41% - 0.67rem)'); 
      } else if (isDesktop) {
        $carousel.find('.gallery-cell').css('width', 'calc(41.67% - 0.67rem)'); 
      } else if (isTablet) {
        $carousel.find('.gallery-cell').css('width', 'calc(50% - 0.5rem)'); 
      } else {
        $carousel.find('.gallery-cell').css('width', '100%'); 
      }
      
      $carousel.addClass('social-reviews-carousel-initialized');
      $carousel.closest('.social-reviews-carousel').addClass('initialized');

      var $section = $carousel.closest('.social-reviews-carousel');
      var $prevButton = $section.find('.social-reviews-carousel__nav-button--prev');
      var $nextButton = $section.find('.social-reviews-carousel__nav-button--next');
      var $navContainer = $section.find('.social-reviews-carousel__nav');

      if ($navContainer.length === 0) {
        var $header = $section.find('.social-reviews-carousel__header');
        if ($header.length > 0) {
          $navContainer = $('<div class="social-reviews-carousel__nav"></div>');
          $prevButton = $('<button class="social-reviews-carousel__nav-button social-reviews-carousel__nav-button--prev" aria-label="Previous reviews">'</button>');
          $nextButton = $('<button class="social-reviews-carousel__nav-button social-reviews-carousel__nav-button--next" aria-label="Next reviews">'</button>');
          
          $navContainer.append($prevButton).append($nextButton);
          $header.append($navContainer);
        }
      }

       $prevButton.off('click.socialReviewsCarousel').on('click.socialReviewsCarousel', function(e) {
        e.preventDefault();
        
        var flkty = $carousel.data('flickity');
        if (!flkty) return;
        
        var currentIndex = flkty.selectedIndex;
        var jumpBy = 1; 
        
        
        if (currentIndex === 0) {
          if (isLargeScreen) {
            jumpBy = 3; 
          } else if (isDesktop || isTablet) {
            jumpBy = 2; 
          }
        }
        
        var newIndex = Math.max(0, currentIndex - jumpBy);
        $carousel.flickity('select', newIndex);
      });

       $nextButton.off('click.socialReviewsCarousel').on('click.socialReviewsCarousel', function(e) {
        e.preventDefault();
        
        var flkty = $carousel.data('flickity');
        if (!flkty) return;
        
        var currentIndex = flkty.selectedIndex;
        var jumpBy = 1; 
        
        
        if (currentIndex === 0) {
          if (isLargeScreen) {
            jumpBy = 3; 
          } else if (isDesktop || isTablet) {
            jumpBy = 2; 
          }
        }
        
        var newIndex = Math.min(flkty.slides.length - 1, currentIndex + jumpBy);
        $carousel.flickity('select', newIndex);
      });

      function updateButtonStates() {
        var flkty = $carousel.data('flickity');
        if (!flkty) {
          return;
        }

        var canGoPrev = flkty.selectedIndex > 0;
        var canGoNext = flkty.selectedIndex < (flkty.slides.length - 1);

        $prevButton.prop('disabled', !canGoPrev);
        $nextButton.prop('disabled', !canGoNext);

        var needsNavigation = slideCount > (isLargeScreen ? 3.4 : isDesktop ? 2.4 : isTablet ? 2 : 1);
        $navContainer.toggle(needsNavigation);
      }

       $carousel.off('select.socialReviewsCarousel settle.socialReviewsCarousel')
               .on('select.socialReviewsCarousel', function() {
                 $carousel.find('.gallery-cell').removeAttr('aria-selected');
                 updateButtonStates();
               })
               .on('settle.socialReviewsCarousel', function() {
                 $carousel.find('.gallery-cell').removeAttr('aria-selected');
                 updateButtonStates();
               });

        $carousel.trigger('select.flickity');

         var resizeTimeout;
       $(window).off('resize.socialReviewsCarousel').on('resize.socialReviewsCarousel', function() {
         clearTimeout(resizeTimeout);
         resizeTimeout = setTimeout(function() {
           var newWindowWidth = $(window).width();
           var newIsLargeScreen = newWindowWidth >= 1800;
           var newIsDesktop = newWindowWidth >= 1439 && newWindowWidth < 1800;
           var newIsTablet = newWindowWidth >= 768 && newWindowWidth < 1438;
           var newIsMobile = newWindowWidth < 768;
           
           if (newIsLargeScreen !== isLargeScreen || newIsDesktop !== isDesktop || newIsTablet !== isTablet || newIsMobile !== isMobile) {
             isLargeScreen = newIsLargeScreen;
             isDesktop = newIsDesktop;
             isTablet = newIsTablet;
             isMobile = newIsMobile;
             
             $carousel.find('.gallery-cell').css('width', '');
             
             $carousel.flickity('destroy');
             socialReviewsCarousel.init();
           }
         }, 300);
       });
    });
  },

  unload: function($target) {
    var $carousel = $target.find('.js-social-reviews-carousel');
    if ($carousel.hasClass('flickity-enabled')) {
      $carousel.flickity('destroy');
    }
    $(window).off('resize.socialReviewsCarousel');
  }
};

$(document).ready(function() {
  socialReviewsCarousel.init();
});

$(document).on('shopify:section:load', function(event) {
  socialReviewsCarousel.init();
});

$(document).on('shopify:section:unload', function(event) {
  socialReviewsCarousel.unload($(event.target));
});
